export function normalizeEmail(value) {
  return String(value || '').trim().toLowerCase()
}

export function isUserNotConfirmedError(error) {
  return error?.code === 'UserNotConfirmedException'
}

export function isExpiredVerificationCodeError(error) {
  return error?.code === 'ExpiredCodeException'
}

export function isInvalidVerificationCodeError(error) {
  return error?.code === 'CodeMismatchException'
}

export function buildConfirmEmailPath(email) {
  const normalizedEmail = normalizeEmail(email)
  return normalizedEmail
    ? `/confirm-email?email=${encodeURIComponent(normalizedEmail)}`
    : '/confirm-email'
}
